import { useAppSelector } from "@app/hooks";
import { useIsAuthenticated } from "@azure/msal-react";
import { Loader } from "@components/Loader";
import { LocalStorageKey, useLocalStorage } from "@helpers/localStorageHelper";
import { NavItems } from "@helpers/navigation";
import { useApi } from "@services/useApi";
import { useStripe } from "@stripe/react-stripe-js";
import { useEffect } from "react";
import { useNavigate } from "react-router";

export const Checkout = (): JSX.Element => {
    const { createPurchase } = useApi();
    const stripe = useStripe();
    const navigate = useNavigate();
    const userDetail = useAppSelector((x) => x.userDetail);
    const [assessmentBasket, setAssessmentBasket] = useLocalStorage<AssessmentBasket>(LocalStorageKey.AssessmentBasket);
    const isAuthenticated = useIsAuthenticated();
    const organization = useAppSelector((x) => x.organization);

    const handleCreatePurchase = async (): Promise<void> => {
        let organizationId = assessmentBasket.organizationId;
        if (
            (assessmentBasket.organizationId === undefined || assessmentBasket.organizationId === 0) &&
            isAuthenticated
        ) {
            organizationId = organization.id!;
        }

        if (!assessmentBasket || assessmentBasket.quantity === 0) {
            navigate(NavItems.Purchase.Pricing.path);
            return;
        }

        const sessionId = await createPurchase(organizationId, assessmentBasket.quantity).finally(() => {
            setAssessmentBasket({ ...assessmentBasket, quantity: 0 });
        });

        const error = await stripe?.redirectToCheckout({ sessionId });
        error && console.error(error);

        navigate(NavItems.Purchase.PurchaseCompleted.path);
    };

    useEffect(() => {
        if (userDetail.id !== "") {
            void handleCreatePurchase();
        }
    }, [userDetail]);

    return <Loader />;
};

export interface AssessmentBasket {
    quantity: number;
    organizationId: number;
}
